import React, { Component, Fragment } from "react"
import HeroHeader from "components/hero-header"
import PageContainer from "components/common/PageContainer"

import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"
import { withRouter } from "react-router-dom"

import { fetchFeaturedMaterial, fetchTopCourses } from "store/landing/action"

import { FAQS_LINK } from "constants/config"

import "styles/pages/landing.scss"
import styled from "styled-components"

const routeList = {
  "/": "Home",
  "/faqs": "Frequenty Asked Questions",
}

const IframeContainer = styled.iframe`
  margin: 0 auto;
  position: relative;
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
`

class FAQPage extends Component {
  render() {
    const {
      school: { schoolData },
    } = this.props

    const faqLink = FAQS_LINK["school-" + schoolData?.id]

    return (
      <Fragment>
        <PageContainer>
          <HeroHeader
            title="Frequently Asked Questions"
            routeList={routeList}
            activeColor={schoolData.primary_color}
            activeItem="Frequenty Asked Questions"
          />
          {faqLink && <IframeContainer src={faqLink} />}
        </PageContainer>
      </Fragment>
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ fetchTopCourses, fetchFeaturedMaterial }, dispatch)

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withRouter
)(FAQPage)
